<div class="modal-header">
  <h4 class="modal-title">Are you sure?</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
  </button>
</div>
<div class="modal-body">
  <p>
    You’ll be missing out on news and exclusive offers for you and your pet!
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger text-white" ngbAutofocus (click)="activeModal.close()">
    Go back
  </button>
  <button type="button" class="btn btn-success text-white" (click)="activeModal.dismiss()">
    Yes I'm sure
  </button>
</div>
